module.exports = __webpack_public_path__ + "static/files/anna_bolgrien.722a63a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anna_bolgrien.jpg
// module id = 735S
// module chunks = 0